module.exports = __webpack_public_path__ + "static/media/Utilities.290e0088.svg";